import React from "react";
import cloneDeep from "lodash/cloneDeep";
import styled from "styled-components";
import { Clearfix } from "components/bootstrap";
import { replaceBooleanExpressionOperatorInGroup } from "logic/alerts/AggregationExpressionConfig";
import BooleanOperatorSelector from "./BooleanOperatorSelector";
import AggregationConditionExpression from "../AggregationConditionExpression";
const Group = styled.div`
  padding-left: 40px;
`;
const GroupExpression = ({
  expression,
  level,
  onChange,
  onChildChange,
  validation = {},
  ...props
}) => {
  const handleOperatorChange = (nextOperator) => {
    const nextExpression = cloneDeep(expression);
    nextExpression.operator = nextOperator;
    nextExpression.child = replaceBooleanExpressionOperatorInGroup(nextOperator, nextExpression.child);
    onChange({ conditions: nextExpression });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    BooleanOperatorSelector,
    {
      operator: expression.operator,
      onOperatorChange: handleOperatorChange,
      placeholder: `Boolean operator group ${level + 1}`
    }
  ), /* @__PURE__ */ React.createElement(Clearfix, null), /* @__PURE__ */ React.createElement(Group, null, /* @__PURE__ */ React.createElement(
    AggregationConditionExpression,
    {
      ...props,
      expression: expression.child,
      validation: validation.child,
      parent: expression,
      onChange: onChildChange("child"),
      level: level + 1
    }
  )));
};
export default GroupExpression;
